import { useContext, useState, useEffect } from 'react';
import { GlobalsContext } from '../context/globals';

export const useToogleLanguage = () => {
	const {
		state: { language },
		dispatch,
	} = useContext(GlobalsContext);
	const [state, setState] = useState('');
	useEffect(() => {
		setState(localStorage.getItem('language') || 'es');
	}, []);
	const languageChanger = selected => {
		setState(selected);
		languageChangerOnStore(selected);
	};
	const languageChangerOnStore = languageS => {
		localStorage.setItem('language', languageS);
		dispatch({ language: languageS });
	};
	return { language, languageChanger, state };
};
